(() => {
  const OPTION_SELECTOR = '.shopify-pc__prefs__option';
  const TOGGLE_CLASS = 'shopify-pc__prefs__option-toggle';

  function closeOption(option) {
    option.classList.remove('is-open');
    const toggle = option.querySelector(`.${TOGGLE_CLASS}`);
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function openOption(option) {
    option.classList.add('is-open');
    const toggle = option.querySelector(`.${TOGGLE_CLASS}`);
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', 'true');
  }

  function toggleOption(option, root) {
    const isOpen = option.classList.contains('is-open');
    root.querySelectorAll(`${OPTION_SELECTOR}.is-open`).forEach(closeOption);
    if (!isOpen) openOption(option);
  }

  function isCheckboxControl(target) {
    if (!(target instanceof Element)) return false;
    if (target.closest('input[type="checkbox"]')) return true;
    // Custom checkbox square rendered as label > span
    if (target.matches('label span') || target.closest('label > span')) return true;
    return false;
  }

  function initPrefsAccordion(root) {
    root.querySelectorAll(OPTION_SELECTOR).forEach((option) => {
      if (option.dataset.accordionInit === 'true') return;
      if (!option.querySelector('p')) return;

      option.dataset.accordionInit = 'true';

      const label = option.querySelector('label');
      if (!label) return;

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = TOGGLE_CLASS;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Toggle cookie category description');
      toggle.setAttribute('tabindex', '-1');

      label.after(toggle);

      option.addEventListener('click', (event) => {
        if (isCheckboxControl(event.target)) return;

        event.preventDefault();
        toggleOption(option, root);
      });
    });
  }

  function observePrefsDialog() {
    const existing = document.querySelector('#shopify-pc__prefs__dialog');
    if (existing) initPrefsAccordion(existing);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          const dialog =
            node.id === 'shopify-pc__prefs__dialog'
              ? node
              : node.querySelector?.('#shopify-pc__prefs__dialog');

          if (dialog) initPrefsAccordion(dialog);
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observePrefsDialog);
  } else {
    observePrefsDialog();
  }
})();
